// How long a dashboard save may take before it's cancelled, so a hung request
// can't block the saves queued after it.
export const DASHBOARD_SAVE_TIMEOUT_MS = 30000;
